<template>
  <div class="reelbuzz">
    <menuBox :step="1"></menuBox>
    <div class="reelbuzz-content">
      <div class="reelbuzz-box">
        <p class="bt">Unlock endless drama and discover more unknown worlds.</p>
        <span class="title"
          >More exciting things are waiting for you to open</span
        >
        <div class="imgList">
          <img src="../assets/googleImg.png" alt="" @click="changeRoute(1)" />
          <img src="../assets/appstoreImg.png" alt="" @click="changeRoute(2)" />
        </div>
        <div class="isiUlang" @click="link">
          <div class="wallet-div">
            <img class="wallet" src="../assets/wallet.png" />top-up
          </div>
          <div class="shuxian"></div>
          <div class="tambahan">
            <div class="tambahan-text">
              <div>Extra +3% reward Bonus</div>
              <div>Restricted to this entry point</div>
            </div>
            <img class="gold" src="../assets/gold-coin.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="drama-box">
      <img class="imgTOP" src="../assets/dramaImg.png" alt="" />
      <div class="title">
        <p>Popular</p>
        <span>drama</span>
      </div>
      <div class="item-box">
        <div class="item">
          <img src="../assets/info1.png" alt="" />
          <p>Love in the Passing Rain and Clearing Skies</p>
        </div>
        <div class="item">
          <img src="../assets/info2.png" alt="" />
          <p>Madam, the President is running errands again</p>
        </div>
        <div class="item">
          <img src="../assets/info3.png" alt="" />
          <p>When the Delicate Meets the Rough</p>
        </div>
        <div class="item">
          <img src="../assets/info4.png" alt="" />
          <p>Proud Supreme Dragon</p>
        </div>
      </div>
    </div>
    <div class="collection-box-left">
      <div class="left">
        <div class="title">
          A collection of exciting dramas from around the world
        </div>
        <div class="text">
          Romance, city, fantasy, time travel, suspense, various themes to meet
          your various preferences
        </div>
      </div>
      <div class="right">
        <img src="../assets/collection1.png" alt="" />
      </div>
    </div>
    <div class="collection-box-right">
      <div class="right">
        <img src="../assets/collection2.png" alt="" />
      </div>
      <div class="left">
        <div class="title">Personalized recommendation of exciting content</div>
        <div class="text">
          Pay attention to your preferences and push more exciting news every
          day
        </div>
      </div>
    </div>
    <div class="collection-box-left">
      <div class="left">
        <div class="title">Watch great content for free</div>
        <div class="text">
          Complete daily tasks to get rewards to unlock videos for free.
        </div>
      </div>
      <div class="right">
        <img src="../assets/collection3.png" alt="" />
      </div>
    </div>
    <footerBox :step="1"></footerBox>
  </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "home",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      type: 1,
    };
  },
  mounted() {},
  methods: {
    changeRoute(val) {
      if (val == 1) {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.reelbuzz.tv";
      } else {
        window.location.href =
          "https://apps.apple.com/id/app/reelbuzz/id6480157261";
      }
    },
    link() {
      window.open("https://pay.reelbuzztv.com/home", "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.reelbuzz-content {
  position: relative;
  top: -100px;

  .reelbuzz-box {
    background-image: url(../assets/home.png);
    width: 100%;
    height: 1080px;
    background-size: 100% 100%;
    padding: 336px 360px 0 360px;
    text-align: center;
    overflow: hidden;
    box-sizing: border-box;

    .bt {
      margin-bottom: 40px;
      font-family: Lexend, Lexend;
      font-weight: 600;
      font-size: 70px;
      color: #ffffff;
      line-height: 82px;
    }

    .title {
      display: block;
      margin-bottom: 60px;
      font-family: Lexend, Lexend;
      font-size: 40px;
      color: #ffffff;
      line-height: 32px;
    }

    .imgList {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      width: 650px;
      margin: 0 auto;
      img {
        // margin-left: 40px;
        width: 292px;
        height: 87px;
      }
    }
    .isiUlang {
      color: #824805;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      width: 610px;
      margin: 30px auto;
      padding: 15px 20px;
      border-radius: 23px;
      border: 1px gray solid;
      font-size: 25px;
      font-weight: 600;
      background: linear-gradient(90deg, #ffe090 0%, #ffb851 100%);
      cursor: pointer;
      .shuxian {
        border: 1px dashed #824805;
        height: 40px;
        width: 0px;
      }
      .tambahan {
        margin-left: 30px;
        display: flex;
        align-items: center;
        .tambahan-text {
          :nth-child(1) {
            display: flex;
            align-items: center;
            font-size: 20px;
          }
          :nth-child(2) {
            font-size: 18px;
            font-weight: 500;
            color: #bb6404;
          }
        }

        .gold {
          width: 35px;
          height: 35px;
          margin-left: 10px;
        }
      }
      .wallet-div {
        display: flex;
        align-items: center;
        font-size: 24px;
        .wallet {
          width: 60px;
          height: 60px;
          margin-right: 10px;
        }
      }
    }
  }
}

.drama-box {
  padding: 100px 360px 200px;
  text-align: center;

  .imgTOP {
    margin: 0 auto 40px;
    width: 80px;
    height: 20px;
  }

  .title {
    display: flex;
    justify-content: center;
    font-family: Lexend, Lexend;
    font-weight: 600;
    font-size: 64px;
    line-height: 64px;

    p {
      color: #333333;
      margin-right: 24px;
    }

    span {
      background: linear-gradient(0deg, #ff946c 69%, #fdd558 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .item-box {
    display: flex;
    justify-content: space-between;
    margin-top: 80px;
    box-sizing: border-box;

    .item {
      width: 264px;
      margin-right: 48px;

      img {
        width: 264px;
        height: 352px;
        border-radius: 16px 16px 16px 16px;
      }

      p {
        text-align: left;
        margin-top: 24px;
        font-size: 26px;
        color: #333333;
        line-height: 28px;
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }
}

.collection-box-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 200px 360px;

  img {
    width: 945px;
    height: 878px;
    /* 起始位置 */
    transform: rotateZ(30deg);
    /* 改变变形原点 */
    transform-origin: right bottom;
    /* 透明 */
    opacity: 0;

    /* 应用动画 */
    animation: boxmove 2s ease 1;
    /* 动画之外的状态 */
    /* backwards 动画完成之后停留在第一帧 */
    /* forwards 动画完成之后停留在最后一帧 */
    animation-fill-mode: forwards;
  }

  /* 创建自定义动画 */
  @keyframes boxmove {
    form {
      transform: rotateZ(30deg);
      opacity: 0;
    }

    to {
      transform: rotateZ(0deg);
      opacity: 1;
    }
  }

  .title {
    margin-bottom: 30px;
    font-family: Poppins, Poppins;
    font-weight: 600;
    font-size: 56px;
    color: #333333;
    line-height: 68px;
  }

  .text {
    font-family: Lexend, Lexend;
    font-weight: 400;
    font-size: 30px;
    color: #333333;
    line-height: 35px;
  }
}

.collection-box-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 360px 200px 0;

  img {
    width: 945px;
    height: 878px;
    /* 起始位置 */
    transform: rotateZ(30deg);
    /* 改变变形原点 */
    transform-origin: left top;
    /* 透明 */
    opacity: 0;
    /* 应用动画 */
    animation: boxmove 2s ease 1;
    /* 动画之外的状态 */
    /* backwards 动画完成之后停留在第一帧 */
    /* forwards 动画完成之后停留在最后一帧 */
    animation-fill-mode: forwards;
  }

  .title {
    margin-bottom: 30px;
    font-family: Poppins, Poppins;
    font-weight: 600;
    font-size: 56px;
    color: #333333;
    line-height: 68px;
  }

  .text {
    font-family: Lexend, Lexend;
    font-weight: 400;
    font-size: 30px;
    color: #333333;
    line-height: 35px;
  }
}
</style>
